import { Trash } from "lucide-react";
import React, { useState } from "react";

export const PainHistory3 = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [addMedication, setAddMedication] = useState(1);
  const [addedMedication, setAddedMedication] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null); // Track which treatment is being edited
  const [medicationInfo, setMedicationInfo] = useState({
    medication: "",
    region: "",
    procedureLastYear: "",
    lastProcedureData: "",
  });

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setMedicationInfo({ ...medicationInfo, [name]: value });
  };

  const handleDelete = (id) => {
    // Confirm deletion
    if (!window.confirm("Are you sure you want to delete this treatment?")) {
      return;
    }
    
    // Delete from addedMedication state
    setAddedMedication((preData) => {
      const safePreData = Array.isArray(preData) ? preData : [];
      return safePreData.filter((item, index) => index !== id);
    });
    
    // Delete from patientMedicationInfo
    setPatientMedicationInfo((preData) => {
      const safeArray = Array.isArray(preData.pastMedicationInfo)
        ? preData.pastMedicationInfo
        : [];
      
      return {
        ...preData,
        pastMedicationInfo: safeArray.filter((_, index) => index !== id),
      };
    });
  };
  return (
    <div className="px-4 py-3 mb-5">
      <div className="w-full bg-white p-5 rounded shadow-sm ">
        <div class="relative overflow-x-auto">
          <table class="w-full text-sm bg-white text-left rtl:text-right   font-mainFont">
            <thead class="text-xs  uppercase   text-black border-t  border-[#d4d4d4]">
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] border-l border-r border-[#d4d4d4]"
                >
                  Interventional Pain Treatment History
                </th>
                <th scope="col" class="px-6 py-3 font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw]">
                  Region
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 border-l border-r border-[#d4d4d4] font-[600] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw]"
                >
                  No.of Procedure Last Year
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 font-[600] border-r border-[#d4d4d4] 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw]"
                >
                  Date of Last Procedure
                </th>
              </tr>
            </thead>

            <tbody>
              {Array(addMedication)
                .join()
                .split(",")
                .map((cur, id) => (
                  <tr key={id} class="bg-white text-black border-b   ">
                    <th
                      scope="row"
                      class="font-medium text-black whitespace-nowrap border border-[#d4d4d4] px-5"
                    >
                      <input
                        className="w-full px-3 py-4 border border-none outline-none"
                        placeholder="Enter treatment name"
                        name="medication"
                        value={medicationInfo.medication}
                        onChange={handleOnChange}
                      />
                    </th>
                    <td class=" border border-[#d4d4d4] w-72">
                      <select
                        onChange={handleOnChange}
                        name="region"
                        value={medicationInfo.region}
                        className="w-full px-5 py-4 border border-none outline-none"
                      >
                        <option value="">Select Region</option>
                        <option value="Neck">Neck</option>
                        <option value="Upper Back">Upper Back</option>
                        <option value="Mid Back">Mid Back</option>
                        <option value="Lower Back">Lower Back</option>
                        <option value="Cervical Spine">Cervical Spine</option>
                        <option value="Thoracic Spine">Thoracic Spine</option>
                        <option value="Lumbar Spine">Lumbar Spine</option>
                        <option value="Sacrum">Sacrum</option>
                        <option value="Coccyx">Coccyx</option>
                        <option value="Shoulder">Shoulder</option>
                        <option value="Hip">Hip</option>
                        <option value="Knee">Knee</option>
                        <option value="Other">Other</option>
                      </select>
                    </td>
                    <td class=" border border-[#d4d4d4] text-[#34495E] font-[400] font-[Poppins]">
                      <input
                        className="w-full px-3 py-4 border border-none outline-none"
                        placeholder="Pick"
                        type="number"
                        onChange={handleOnChange}
                        name="procedureLastYear"
                        value={medicationInfo.procedureLastYear}
                      />
                    </td>
                    <td class=" border border-[#d4d4d4] flex flex-col justify-start items-start gap-1">
                      <input
                        className="w-full px-3 py-4 border border-none outline-none"
                        placeholder="Enter Period taken"
                        type="date"
                        onChange={handleOnChange}
                        name="lastProcedureData"
                        value={medicationInfo.lastProcedureData}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          <button
            type="button"
            onClick={() => {
              // Validate that at least treatment name is provided
              if (!medicationInfo.medication || medicationInfo.medication.trim() === "") {
                alert("Please enter a treatment name before adding.");
                return;
              }
              
              // Create treatment object
              const newTreatment = {
                medication: medicationInfo.medication.trim(),
                region: medicationInfo.region || "",
                procedureLastYear: medicationInfo.procedureLastYear || "",
                lastProcedureData: medicationInfo.lastProcedureData || "",
              };
              
              // Add to addedMedication state
              setAddedMedication([...addedMedication, newTreatment]);
              
              // Add to patientMedicationInfo
              const currentArray = Array.isArray(patientMedicationInfo?.pastMedicationInfo)
                ? patientMedicationInfo.pastMedicationInfo
                : [];
              
              setPatientMedicationInfo({
                ...patientMedicationInfo,
                pastMedicationInfo: [...currentArray, newTreatment],
              });
              
              // Clear the form
              setMedicationInfo({
                medication: "",
                region: "",
                procedureLastYear: "",
                lastProcedureData: "",
              });
            }}
            className="bg-secondaryColo BTNGradientBg  text-white font-mainFont font-[500] w-full py-3 2xl:text-[1.1vw] xl:text-[1.1vw] lg:text-[1.1vw] md:text-[2.3vw] text-[3.5vw] hover:opacity-90 transition-all duration-200"
          >
            Add Treatment
          </button>
        </div>

        <div className=" flex justify-start w-full  gap-5 flex-wrap my-5">
          {patientMedicationInfo.pastMedicationInfo.map((curMedication, id) => (
            <div
              key={id}
              className="border border-[#d4d4d4] bg-white   p-5 rounded-xl flex flex-col gap-4 2xl:max-w-[20dvw] xl:max-w-[20dvw] lg:max-w-[20dvw] md:max-w-[20dvw] max-w-[100dvw]"
            >
              <div className="flex justify-between items-center">
                <h3 className="2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw] font-[700] text-[#333333]">
                  Treatment {id + 1}
                </h3>
                <div className="flex gap-2">
                  <button
                    onClick={() => {
                      // Load treatment into form for editing
                      setMedicationInfo({
                        medication: curMedication?.medication || "",
                        region: curMedication?.region || "",
                        procedureLastYear: curMedication?.procedureLastYear || "",
                        lastProcedureData: curMedication?.lastProcedureData || "",
                      });
                      setEditingIndex(id);
                    }}
                    className="p-2 flex justify-center items-center hover:text-white hover:bg-blue-400 transition-all duration-200 ease-linear rounded-full shadow-lg"
                    title="Edit treatment"
                  >
                    ✏️
                  </button>
                  <button
                    onClick={() => handleDelete(id)}
                    className="p-2 flex justify-center items-center hover:text-white hover:bg-red-400 transition-all duration-200 ease-linear rounded-full shadow-lg"
                    title="Delete treatment"
                  >
                    <Trash size={15} />
                  </button>
                </div>
              </div>
              {editingIndex === id ? (
                // Edit mode
                <div className="flex flex-col gap-3">
                  <input
                    className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                    placeholder="Treatment name"
                    value={medicationInfo.medication}
                    onChange={(e) => setMedicationInfo({...medicationInfo, medication: e.target.value})}
                  />
                  <select
                    className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                    value={medicationInfo.region}
                    onChange={(e) => setMedicationInfo({...medicationInfo, region: e.target.value})}
                  >
                    <option value="">Select Region</option>
                    <option value="Neck">Neck</option>
                    <option value="Upper Back">Upper Back</option>
                    <option value="Mid Back">Mid Back</option>
                    <option value="Lower Back">Lower Back</option>
                    <option value="Cervical Spine">Cervical Spine</option>
                    <option value="Thoracic Spine">Thoracic Spine</option>
                    <option value="Lumbar Spine">Lumbar Spine</option>
                    <option value="Sacrum">Sacrum</option>
                    <option value="Coccyx">Coccyx</option>
                    <option value="Shoulder">Shoulder</option>
                    <option value="Hip">Hip</option>
                    <option value="Knee">Knee</option>
                    <option value="Other">Other</option>
                  </select>
                  <input
                    className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                    placeholder="No. of procedures last year"
                    type="number"
                    value={medicationInfo.procedureLastYear}
                    onChange={(e) => setMedicationInfo({...medicationInfo, procedureLastYear: e.target.value})}
                  />
                  <input
                    className="w-full px-3 py-2 border border-[#d4d4d4] rounded outline-none"
                    placeholder="Date of last procedure"
                    type="date"
                    value={medicationInfo.lastProcedureData}
                    onChange={(e) => setMedicationInfo({...medicationInfo, lastProcedureData: e.target.value})}
                  />
                  <div className="flex gap-2">
                    <button
                      onClick={() => {
                        // Save edited treatment
                        const updatedTreatment = {
                          medication: medicationInfo.medication.trim(),
                          region: medicationInfo.region || "",
                          procedureLastYear: medicationInfo.procedureLastYear || "",
                          lastProcedureData: medicationInfo.lastProcedureData || "",
                        };
                        
                        const updatedList = [...patientMedicationInfo.pastMedicationInfo];
                        updatedList[id] = updatedTreatment;
                        
                        setPatientMedicationInfo({
                          ...patientMedicationInfo,
                          pastMedicationInfo: updatedList,
                        });
                        
                        // Clear form and exit edit mode
                        setMedicationInfo({
                          medication: "",
                          region: "",
                          procedureLastYear: "",
                          lastProcedureData: "",
                        });
                        setEditingIndex(null);
                      }}
                      className="px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600"
                    >
                      Save
                    </button>
                    <button
                      onClick={() => {
                        // Cancel editing
                        setMedicationInfo({
                          medication: "",
                          region: "",
                          procedureLastYear: "",
                          lastProcedureData: "",
                        });
                        setEditingIndex(null);
                      }}
                      className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              ) : (
                // View mode
                <>
                  <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                    <strong>Treatment</strong> :{" "}
                    <span className="font-[400] text-black 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw]">
                      {curMedication?.medication}
                    </span>
                  </h3>
                  <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                    <strong>Region</strong> :{" "}
                    <span className="font-[400] text-black 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw]">
                      {curMedication?.region}
                    </span>
                  </h3>
                  <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                    <strong>No.of Procedure Last Year</strong> :{" "}
                    <span className="font-[400] text-black 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw]">
                      {curMedication?.procedureLastYear}
                    </span>
                  </h3>
                  <h3 className="2xl:text-[1dvw] xl:text-[1dvw] lg:text-[1dvw] md:text-[1dvw] text-[3.5dvw] font-[500] font-mainFont text-[#333333]/70">
                    <strong>Date of Last Procedure</strong> :{" "}
                    <span className="text-black font-[400] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5dvw]">
                      {curMedication?.lastProcedureData}
                    </span>
                  </h3>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
